import React from 'react';

export default function MarqueeBar({ text }) {
  return (
    <div className="row mx-0 align-items-center">
      <div className="col-12 text-right px-0">
        <span className="msgs marquee">
          <span><i className="bi bi-envelope-fill me-1" /> {text} </span>
        </span>
      </div>
    </div>
  );
}
